import { StaffAccessLevels } from '@/enums/StaffAccessLevels';

export const MaintenanceMixin = {
  filters: {
    capitalize(value) {
      if (!value) return "";
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  async created() {
    await this.$store.dispatch("getMaintenanceTemplates");
  },
  computed: {
    isAdmin(): boolean {
      return [
        StaffAccessLevels.OrgAdmin,
        StaffAccessLevels.MaintenanceAdmin
      ].includes(this.$store.state.authModule.user.accessLevel);
    },
    isAdminMaintenance(): boolean {
      return [
        StaffAccessLevels.OrgAdmin,
        StaffAccessLevels.MaintenanceAdmin,
        StaffAccessLevels.HomeAdmin
      ].includes(this.$store.state.authModule.user.accessLevel);
    }
  },
  methods: {
    getIcon(inputIcon: string) {
      if (!inputIcon) return 'mdi-alert-circle-outline';
      
      const chars = inputIcon.split('');

      for (let i = 0; i < chars.length; i++) {
        if (chars[i] === chars[i].toUpperCase() && chars[i] !== "-") {
          chars[i] = '-' + chars[i].toLowerCase();
        }
      }

      return 'mdi-' + chars.join('');
    },
    transformBooleanToTitle(value: boolean): string {
      return value ? "True" : "False"
    },
    uppercaseTitle(value: string): string {
      if (!value) return value;
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    nameForm(templateId: string): string {
      return this.$store.state.maintenanceModule.maintenanceTemplates.find(x => x.id === templateId)?.name;
    },
    nameLocation(locationId: string): string {
      return this.$store.state.eventLocationModule.eventLocations.find(x => x.id === locationId)?.name;
    },
    async deleteForm(form, scheduledRequestId) {
      const response = await this.$refs.confirmDlg.open(null, this.$t("MaintenanceSchedule.MaintenanceFormDeleteMessage"), false);

      if (!response || !response.agree) {
        return false;
      }

      await this.$store.dispatch("deleteMaintenanceFormFromMaintenanceSchedule", {
        maintenanceScheduleId: scheduledRequestId,
        form: form
      });

      await this.$store.dispatch('deleteMaintenanceFormsByScheduledMaintenance', {
        maintenanceScheduleId: scheduledRequestId,
        form: form
      });

      await this.$store.dispatch('deleteMaintenanceFormsFromRequestsByScheduledId', {
        maintenanceScheduleId: scheduledRequestId,
        form: form
      });

      await this.$store.dispatch('getScheduledMaintenanceById', this.$route.params.id);

      await this.$store.dispatch('getMaintenanceFormsByScheduledMaintenanceId', this.$route.params.id);

      await this.$store.dispatch('getRequestsByScheduledMaintenanceId', this.$route.params.id);

      this.$toast.open({
        type: "success",
        message: this.$t("MaintenanceView.FormDeleted")
      });

      return true;
    },
  }
}